import Swiper from 'swiper'
import { Autoplay, Navigation, Pagination, EffectFade } from 'swiper/modules'

export default (function () {
    document.querySelectorAll('[data-hero-slider]').forEach((instance) => {
        const sliderType = instance.getAttribute('data-hero-slider')
        let options = {
            modules: [Pagination, Navigation, Autoplay, EffectFade],
            pagination: {
                enabled: true,
                clickable: true,
                el: '.hero-swiper-pagination',
            },
            navigation: {
                nextEl: '.hero-swiper-button-next',
                prevEl: '.hero-swiper-button-prev',
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            speed: 500,
            allowTouchMove: false,
            loop: true,
            autoHeight: true,
            on: {
                init: function() {
                    instance.parentElement.classList.remove('opacity-0')
                    instance.parentElement.classList.remove('visually-hidden')
                    const nav = instance.parentElement.parentElement.querySelector('.hero-swiper-pagination-wrapper')
                    nav.classList.remove('opacity-0')
                    nav.classList.remove('visually-hidden')
                }
            }
        }

        if (sliderType === 'media') {
            options = {
                ...options
            }
        }

        // eslint-disable-next-line no-new
        new Swiper(instance, options)
    })
})
